import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TOOL_LIBRARY_BASE_API_URL } from '@tfs/tool-library-tokens';

import { Profile } from '../models/auth.models';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http = inject(HttpClient);
  private baseApiUrl = inject(TOOL_LIBRARY_BASE_API_URL);
  /**
   * Fetches the user profile from the backend.
   * Called by APP_INITIALIZER to check authentication before app bootstrap.
   */
  getUserProfile(): Observable<Profile> {
    return this.http.get<Profile>(`${this.baseApiUrl}/library/profile`);
  }

  /**
   * Trigger backend login
   */
  login(returnUrl?: string): void {
    // Construct return url
    const currentUrl = new URL(returnUrl || window.location.href);
    currentUrl.searchParams.delete('login_hint');

    // Construct the sanitized returnUrl
    const sanitizedReturnUrl = `${currentUrl.origin}${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`;
    const encodedReturnUrl = encodeURIComponent(sanitizedReturnUrl);

    // Extract login_hint from the current URL
    const urlParams = new URLSearchParams(window.location.search);
    const loginHint = urlParams.get('login_hint');
    const loginHintParam = loginHint ? `&login_hint=${encodeURIComponent(loginHint)}` : '';

    // Construct the login URL without including login_hint in returnUrl
    window.location.assign(
      `${this.baseApiUrl}/auth/login?returnUrl=${encodedReturnUrl}${loginHintParam}`
    );
  }

  /**
   * Trigger backend logout
   */
  logout(returnUrl?: string): void {
    const encodedReturnUrl = returnUrl ?? `${window.location.protocol}//${window.location.host}`;
    window.location.assign(`${this.baseApiUrl}/auth/logout?returnUrl=${encodedReturnUrl}`);
  }
}
